export default __webpack_public_path__ + "static/media/巫芳璟.10ecc3a4.jpg";